<template>
  <div class="report-comp-bd ubv">
    <div class="header">
      <el-radio-group v-model="formSearch.reportType" @change="onTypeChange">
        <el-radio-button :label="item.value" v-for="(item, index) in reportTypeData" :key="index">{{ item.label }}</el-radio-button>
      </el-radio-group>
      <div class="ub" style="float: right">
        <div style="width: 380px; text-align: right; margin-left: auto">
          <!-- 天 -->
          <custom-date-picker
            v-show="formSearch.reportType === 0"
            v-model="dateTimes"
            :init-value="initValue"
            type="daterange"
            align="right"
            unlink-panels
            value-format="YYYY-MM-DD HH:mm:ss"
            @init="onTypeChange"
            @change="onTypeChange"
            :start-placeholder="$t('dashboard_report_kai_shi_ri')"
            :end-placeholder="$t('dashboard_report_jie_shu_ri')"
          ></custom-date-picker>
          <!-- 历史报表 -->
          <!-- 年 -->
          <year-picker v-show="formSearch.reportType === 1" v-model="reportYearTime" class="year-picker" @change="onTypeChange"></year-picker>
          <!-- 季度 -->
          <season-picker v-show="formSearch.reportType === 2" v-model="reportSeasonTime" ref="jidupicker" class="season-picker" @change="onTypeChange"></season-picker>
          <!-- 月 -->
          <el-date-picker
            v-show="formSearch.reportType === 3"
            v-model="reportMonthTime"
            type="monthrange"
            range-separator="—"
            :format="$getElFormat('yyyy-MM', true)"
            value-format="yyyy-MM"
            align="right"
            placeholder=""
            :picker-options="pickerOptionsMonth"
            :clearable="false"
            @change="onTypeChange"
            :start-placeholder="$t('dashboard_report_kai_shi_yue')"
            :end-placeholder="$t('dashboard_report_jie_shu_yue')"
          ></el-date-picker>
          <!--周 -->
          <week-picker v-show="formSearch.reportType === 4" v-model="reportWeekTime" class="week-picker" @change="onTypeChange"></week-picker>
        </div>
        <div style="margin-left: 16px">
          <search-input :placeholder="$t('dashboard_report_ji_shen_hao')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </div>
        <div style="margin-left: 16px">
          <el-button type="info" @click="onExport">
            <i class="icon icon-export-excel"></i>
            {{ $t('com_export') }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="table-bd">
      <!-- 美国站是ft² -->
      <custom-table
        v-if="formSearch.reportType === 0 && isUs"
        tableCode="portal_device_log_ft"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        :onlyArr="['reportDate', 'productCode', 'bodyNum', 'manualUsageTimeFormat', 'manualCleanArea', 'autonomousCleanArea', 'autonomousUsageTimeFormat', 'locationName', 'siteName', 'city']"
        :slots="['reportDate', 'manualCleanArea', 'autonomousCleanArea', 'trainingCleanArea']"
        :filterArr="filterArr"
      >
        <template v-slot:reportDate="scope">
          <span>{{ $moment(scope.row.reportDate).format('MM/DD/YYYY') }}</span>
        </template>
        <template v-slot:manualCleanArea="scope">
          <span>{{ $formatLenLocal(scope.row.manualCleanArea) }}</span>
        </template>
        <template v-slot:autonomousCleanArea="scope">
          <span>{{ $formatLenLocal(scope.row.autonomousCleanArea) }}</span>
        </template>
        <template v-slot:trainingCleanArea="scope">
          <span>{{ $formatLenLocal(scope.row.trainingCleanArea) }}</span>
        </template>
      </custom-table>
      <custom-table
        v-if="formSearch.reportType === 0 && !isUs"
        tableCode="portal_device_log"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        :onlyArr="['reportDate', 'productCode', 'bodyNum', 'manualUsageTimeFormat', 'manualCleanArea', 'autonomousCleanArea', 'autonomousUsageTimeFormat', 'locationName', 'siteName', 'city']"
        :filterArr="filterArr"
      ></custom-table>
      <!-- 美国站是ft² -->
      <custom-table
        v-if="formSearch.reportType !== 0 && isUs"
        tableCode="portal_device_log_date_ft"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        :onlyArr="['reportDate', 'productCode', 'bodyNum', 'manualUsageTimeFormat', 'manualCleanArea', 'autonomousCleanArea', 'autonomousUsageTimeFormat', 'locationNameTotal', 'siteName', 'city']"
        :slots="['totalManualAveClean', 'manualAveValue', 'totalAutoAveClean', 'autoAveClean', 'manualCleanArea', 'autonomousCleanArea', 'trainingCleanArea']"
        :filterArr="filterArr"
      >
        <template v-slot:totalManualAveClean="scope">
          <span>{{ $formatLenLocal(scope.row.totalManualAveClean) }}</span>
        </template>
        <template v-slot:manualAveValue="scope">
          <span>{{ $formatLenLocal(scope.row.manualAveValue) }}</span>
        </template>
        <template v-slot:totalAutoAveClean="scope">
          <span>{{ $formatLenLocal(scope.row.totalAutoAveClean) }}</span>
        </template>
        <template v-slot:autoAveClean="scope">
          <span>{{ $formatLenLocal(scope.row.autoAveClean) }}</span>
        </template>
        <template v-slot:manualCleanArea="scope">
          <span>{{ $formatLenLocal(scope.row.manualCleanArea) }}</span>
        </template>
        <template v-slot:autonomousCleanArea="scope">
          <span>{{ $formatLenLocal(scope.row.autonomousCleanArea) }}</span>
        </template>
        <template v-slot:trainingCleanArea="scope">
          <span>{{ $formatLenLocal(scope.row.trainingCleanArea) }}</span>
        </template>
      </custom-table>
      <custom-table
        v-if="formSearch.reportType !== 0 && !isUs"
        tableCode="portal_device_log_date"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        :onlyArr="['reportDate', 'productCode', 'bodyNum', 'manualUsageTimeFormat', 'manualCleanArea', 'autonomousCleanArea', 'autonomousUsageTimeFormat', 'locationNameTotal', 'siteName', 'city']"
        @filter="filterChange"
        :filterArr="filterArr"
      ></custom-table>
    </div>
    <div class="page-footer">
      <custom-pagination :radius="false" :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import seasonPicker from '@/components/quarterlyRangePicker.vue';
import yearPicker from '@/components/yearRangePicker.vue';
import weekPicker from '@/components/weekRangePicker.vue';

// dashboard_report_kai_shi_ri: 开始日// dashboard_report_jie_shu_ri: 结束日// dashboard_report_kai_shi_yue: 开始月// dashboard_report_jie_shu_yue: 结束月// dashboard_report_ji_shen_hao: 机身号// dashboard_report_ri: 日// dashboard_report_zhou: 周// dashboard_report_yue: 月// dashboard_report_ji: 季// dashboard_report_nian: 年// dashboard_report_zui_jin_yi_zhou: 最近一周// dashboard_report_zjygy: 最近一个月// dashboard_report_zjsgy: 最近三个月

export default {
  name: 'report',
  components: {
    seasonPicker,
    yearPicker,
    weekPicker,
  },
  computed: {
    reportTypeData() {
      return [
        {
          label: this.$t('dashboard_report_ri'),
          value: 0,
        },
        {
          label: this.$t('dashboard_report_zhou'),
          value: 4,
        },
        {
          label: this.$t('dashboard_report_yue'),
          value: 3,
        },
        {
          label: this.$t('dashboard_report_ji'),
          value: 2,
        },
        {
          label: this.$t('dashboard_report_nian'),
          value: 1,
        },
      ];
    },
    filterArr() {
      if (this.isCoJv) {
        return ['bigCustomerName'];
      }
      return ['customerName', 'bigCustomerName'];
    },
  },
  data() {
    return {
      provide: true,
      formSearch: {
        reportType: 0,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        bodyNum: '',
        productCode: '',
        productName: '',
        locationId: '',
        locationName: '',

        // region: '',
        locationAddress: '',
        afterServiceName: '',
        agentCoName: '',
        customerName: '',

        beginTime: '',
        endTime: '',
        countryCode: '',
        provinceCode: '',
        cityCode: '',
        country: '',
        province: '',
        city: '',
        tagName: '',
      },
      tagId: '',
      tags: [],
      // 日
      initValue: '',
      dateTimes: '',
      reportYearTime: [`${moment(this.$getLocalTime()).year()}`, `${moment(this.$getLocalTime()).year()}`],
      reportSeasonTime: [`${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`, `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`],
      reportMonthTime: [`${moment(this.$getLocalTime()).add('month').format('YYYY-MM')}`, `${moment(this.$getLocalTime()).add('month').format('YYYY-MM')}`],
      reportWeekTime: [this.$momentElLocal(moment().week(moment().week())), this.$momentElLocal(moment().week(moment().week()))],
      tableList: [],
      totalRows: 0,
      // 选择日期配置
      pickerOptionDisAfter: {
        shortcuts: [
          {
            text: this.$t('dashboard_report_zui_jin_yi_zhou'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('dashboard_report_zjygy'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('dashboard_report_zjsgy'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
        disabledDate: time => moment(time).isAfter(this.$getLocalTime(), 'day'),
      },
      pickerOptionsMonth: {
        firstDayOfWeek: 1,
        disabledDate: time => moment(time).isAfter(this.$getLocalTime(), 'day'),
      },
      isFilter: false,
    };
  },

  mounted: function () {
    this.mergeLanguage(null, 'portal_dashboard_report');
    this.initValue = [this.$moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 00:00:00'), this.$moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59')];
    this.formSearch.beginTime = this.dateTimes ? this.dateTimes[0] : '';
    this.formSearch.endTime = this.dateTimes ? this.dateTimes[1] : '';
    // this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 获取列表
    getTableList() {
      // this.formSearch.beginTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[0] : '';
      // this.formSearch.endTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[1] : '';

      if (this.formSearch.reportType === 0) {
        this.$getJSON(apis.portalDeviceReportDailyPage, this.formSearch)
          .then((res) => {
            const data = res.data.list;
            this.nullValueToCrossbar(data, ['assistCount']);
            this.tableList = data;
            this.totalRows = res.data.total;
          })
          .catch(() => {
            this.tableList = [];
          });
      } else {
        // 清空 没有的筛选
        // this.formSearch.region = '';
        this.formSearch.locationAddress = '';
        this.formSearch.countryCode = '';
        this.formSearch.provinceCode = '';
        this.formSearch.cityCode = '';
        this.formSearch.country = '';
        this.formSearch.province = '';
        this.formSearch.city = '';
        this.formSearch.tagName = '';
        this.$getJSON(apis.portalDeviceReportSummaryPage, this.formSearch)
          .then((res) => {
            const data = res.data.list;
            this.nullValueToCrossbar(data, ['assistCount']);
            this.tableList = data;
            this.totalRows = res.data.total;
          })
          .catch(() => {
            this.tableList = [];
          });
      }
    },
    // 获取季度
    getSeason: function (month) {
      if (month < 3) {
        return '01';
      } else if (month < 6) {
        return '02';
      } else if (month < 9) {
        return '03';
      } else if (month < 12) {
        return '04';
      }
      return true;
    },
    onTypeChange() {
      switch (this.formSearch.reportType) {
        case 1:
          this.formSearch.beginTime = this.reportYearTime ? this.reportYearTime[0] : '';
          this.formSearch.endTime = this.reportYearTime ? this.reportYearTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 2:
          this.formSearch.beginTime = this.reportSeasonTime ? this.reportSeasonTime[0] : '';
          this.formSearch.endTime = this.reportSeasonTime ? this.reportSeasonTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 3:
          this.formSearch.beginTime = this.reportMonthTime ? this.reportMonthTime[0] : '';
          this.formSearch.endTime = this.reportMonthTime ? this.reportMonthTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 4:
          // 设置周的开始时间是星期一 1月1号是年开始的第一周
          moment.updateLocale('en', {
            week: {
              // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
              dow: 1, // Monday is the first day of the week.
              doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
            },
          });
          this.formSearch.beginTime = this.reportWeekTime.length ? moment(this.reportWeekTime[0]).format('GGGG-WW') : ''; // 转换时间因为现在是Date类型
          this.formSearch.endTime = this.reportWeekTime.length ? moment(this.reportWeekTime[1]).format('GGGG-WW') : ''; // 转换时间因为现在是Date类型
          this.onPageChange({ page: 1 });
          break;
        default:
          this.formSearch.beginTime = this.dateTimes.length ? this.dateTimes[0] : '';
          this.formSearch.endTime = this.dateTimes.length ? this.dateTimes[1] : '';
          this.onPageChange({ page: 1 });
      }
    },
    // 获取标列表
    getTagsList(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.tagId === item.tagId);
        if (!isHas && item.tagId && item.tagName) {
          arr.push({
            tagId: item.tagId,
            tagName: item.tagName,
          });
        }
      });
      this.tags = arr;
    },
    // 点击标签
    onItemTag(tagId) {
      if (tagId === this.tagId) {
        this.tagId = '';
      } else {
        this.tagId = tagId;
      }
    },
    clearTag(key, name, index) {
      this.formSearch[key].splice(index, 1);
      this.formSearch[name].splice(index, 1);
      this.onPageChange({ page: 1 });
    },
    onClear() {
      this.formSearch.bodyNum = '';
      this.formSearch.productCode = '';
      this.formSearch.productName = '';
      this.formSearch.locationName = '';
      this.formSearch.locationId = '';
      this.formSearch.region = '';
      this.formSearch.locationAddress = '';
      this.formSearch.afterServiceName = '';
      this.formSearch.agentCoName = '';
      this.formSearch.beginTime = '';
      this.formSearch.endTime = '';
      this.formSearch.countryCode = '';
      this.formSearch.provinceCode = '';
      this.formSearch.cityCode = '';

      this.formSearch.tagName = '';
      this.dateTimes = [];
      // this.initValue = [this.$moment().subtract(1, 'day').format('YYYY-MM-DD 00:00:00'), this.$moment().format('YYYY-MM-DD 23:59:59')];
      this.initValue = [];
      this.reportYearTime = [];
      this.reportSeasonTime = [];
      this.reportMonthTime = [];
      this.reportWeekTime = [];
      // initValue会调用到
      // this.onPageChange({ page: 1 });
    },
    // 过滤图标
    dataFilter: function (list) {
      if (!this.tagId) {
        return list;
      }
      return list.filter(t => t.tagId === this.tagId);
    },

    onExport: function () {
      if (this.formSearch.reportType === 0) {
        this.exportTable('portalDeviceReportDailyExport', {
          ...this.formSearch,
          platform: 'portal',
          includeColumnList: [
            'reportDate',
            'productCode',
            'bodyNum',
            'manualUsageTimeFormat',
            'manualCleanArea',
            'autonomousCleanArea',
            'autonomousUsageTimeFormat',
            'locationName',
            'siteName',
            'city',
          ],
        });
      } else {
        this.exportTable('portalDeviceReportSummaryExport', {
          ...this.formSearch,
          platform: 'portal',
          includeColumnList: [
            'reportDate',
            'productCode',
            'bodyNum',
            'manualUsageTimeFormat',
            'manualCleanArea',
            'autonomousCleanArea',
            'autonomousUsageTimeFormat',
            'locationNameTotal',
            'siteName',
            'city',
          ],
        });
      }
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    dataFilterTree: function (list, code) {
      // 要过滤第一层 那children那层
      if (list.length > 0 && list[0].code === code) {
        const node = list[0];
        return node && node.children ? node.children : [];
      } else {
        return list;
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.report-comp-bd {
  height: 100%;
  .header {
    padding: 24px;

    .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 20px 0 0 20px;
    }
    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 20px 20px 0;
    }
    .week-picker,
    .season-picker,
    .year-picker {
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 47% !important;
        &:last-of-type {
          float: right;
        }
      }
    }

    .season-picker {
      display: flex;
      justify-content: space-between;
      .quarter-picker {
        width: 47% !important;
        .el-input {
          width: 100% !important;
        }
        &:last-of-type {
          float: right;
        }
      }
    }
  }
  .table-bd {
    // height: 328px;
    flex: 1;
    padding: 0 24px;
  }
  .page-footer {
    height: 88px;
  }
}
</style>
